<app-search-box #appSearchBox (newSearchEvent)="setSearchString($event)"></app-search-box>
